import { toast } from 'react-toastify';


import { toasterNotification } from './toaster';


export const generateUUID = ({token}) => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = (Math.random() * 16) | 0;
        const v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
};


// twilio===========
export const sendSMS = async () => {
    try {
        const response = await fetch(process.env.REACT_APP_SERVER_URL + '/send-sms', {
            method: 'POST',
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`,
              },
            body: JSON.stringify({
                to: '',
                message: '',
            }),
        });
        const data = await response.json();
        if (data.success) {
            toasterNotification('success', '', 'SMS sent successfully!');
        } else {
            toasterNotification('error', '', `Error: ${data.error}`);
        }
    } catch (error) {
        console.error('Error sending SMS:', error);
    }
};
//sendgrid=====
export const sendEmail = async (token,to, subject, text, html, toastTitle = 'Email sent successfully', showToast = true) => {
    try {
        const response = await fetch(process.env.REACT_APP_SERVER_URL + '/send-email', {
            method: 'POST',
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`,
              },
            body: JSON.stringify({
                to: to,
                subject: subject,
                text: text,
                html: html,
            }),
        });
        const data = await response.json();
        if (data.success) {
            if (showToast) {
                toasterNotification('success', toastTitle, `To ${to}`);
            }
        } else {
            toasterNotification('error', '', `Error: ${data.error}`);
        }
    } catch (error) {
        console.error('Error sending email:', error);
    }
};
export const sendMessages = (to, name, link) => {
    try {
    return fetch(process.env.REACT_APP_SERVER_URL + '/send-message', {
        method: 'POST',
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
          },
        body: JSON.stringify({
            to: to,
            name: name,
            link: link,
        }),
    })
        .then((res) => res.json())
        .then((data) => {
            // 
        });
    } catch (error) {
 
    }
};

export const sendSmsMessage = async (payloadOrTo, messageOrTitle, maybeTitle) => {
    try {
        const url = (process.env.REACT_APP_SERVER_URL || '') + '/send-message';
        const payload = typeof payloadOrTo === 'object'
            ? payloadOrTo
            : { to: payloadOrTo, message: messageOrTitle };
        const toastTitle = typeof payloadOrTo === 'object' ? (maybeTitle || 'SMS Sent!') : (maybeTitle || 'SMS Sent!');
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`,
              },
            body: JSON.stringify(payload),
        });
        const data = await response.json();
        if (data?.success) {
            const to = payload?.to || '';
            toasterNotification('success', toastTitle, to ? `To ${to}` : '');
        } else {
            toasterNotification('error', '', `Error: ${data?.error || 'Failed to send SMS'}`);
        }
    } catch (error) {
        console.error('Error sending sms-message:', error);
        toasterNotification('error', '', 'Failed to send SMS');
    }
};

export const isObjectEmpty = (obj) => {
    return Object.keys(obj).length === 0;
};



export const getProviderAppointments = async (providerId, businessId, accessToken) => {
    try {
        // Validate required parameters
        if (!providerId) {
            throw new Error('Provider ID is required');
        }
        if (!businessId) {
            throw new Error('Business ID is required');
        }

        // Validate access token
        if (!accessToken) {
            throw new Error('No authentication token found');
        }

        // Fetch appointments from backend API
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/api/providers/get-appointments`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${accessToken}`
                },
                body: JSON.stringify({
                    business_id: businessId,
                    provider_id: providerId,
                    status: ['booked', 'pending']
                })
            }
        );

        const result = await response.json();

        if (!response.ok || result.error) {
            const errorMessage = result.error || 'Failed to fetch provider appointments';
            throw new Error(errorMessage);
        }

        // Backend returns { success: true, data: [] } or similar format
        const data = result.data || [];
        return data;
    } catch (error) {
        console.error('Error fetching provider appointments:', error);
        throw error;
    }
};
